var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9957 18.9716C25.0285 19.3926 24.8734 19.8164 24.5721 20.1256C23.9397 20.7757 23.2566 21.397 22.5497 21.964C21.9173 22.4795 21.2402 22.9577 20.5511 23.4015C19.9396 23.791 19.2147 24 18.469 24C18.3527 24 18.2363 23.9914 18.12 23.9828C16.1304 23.8053 11.996 22.7429 6.65361 17.6172C3.98388 15.0543 2.37011 12.7807 1.40662 10.905C0.431202 9.03514 0.112028 7.56042 0.0165736 6.60972C-0.0639656 5.78216 0.150806 4.9546 0.622109 4.27307C1.08446 3.6116 1.58261 2.96157 2.11954 2.3545C2.71016 1.67298 3.36044 1.02009 4.03459 0.413023C4.36271 0.120942 4.8012 -0.0250987 5.23671 0.00353668C5.67222 0.0321721 6.08088 0.24121 6.34935 0.570518C6.93698 1.27781 7.49181 2.01947 8.00488 2.77544C8.60743 3.66028 9.16225 4.58806 9.65444 5.53017C9.96168 6.12006 9.83938 6.82735 9.35614 7.29411L7.73939 8.84615C8.4195 11.1542 9.72006 12.7606 10.7134 13.7084C12.4614 15.3865 14.3913 16.1825 15.7784 16.5634L17.3952 15.0113C17.8784 14.5475 18.6152 14.43 19.2326 14.725C20.217 15.2003 21.1805 15.733 22.1022 16.3085C22.8897 16.8011 23.6623 17.3337 24.3991 17.8978C24.7451 18.1584 24.9599 18.5478 24.9897 18.9659L24.9957 18.9716Z",
    fill: "#081D40"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phone-icon.6b8dd8f86a34f4aaa209b15eaac4c413.svg";
export { ForwardRef as ReactComponent };